import {
  Box,
  Chevron,
  Div,
  H5,
  Icon,
  Logo,
  P,
  dateFormat,
  lightTheme,
} from '@vgrubs/components';
import { SimpleLocationEntity } from 'components/src/types/location.types';
import { Link } from 'react-router-dom';

export const RestaurantComponent = ({
  location,
}: {
  location: SimpleLocationEntity;
}) => {
  return (
    <Link to={`/verifications/restaurant/${location.id}`}>
      <Box $flex $between $alignCenter $mb="8">
        <Div $flex $gap="20px" $gapSM="16px" $alignCenter>
          <Div $flex $flexNone $desktop>
            <Logo width="70" height="70" />
          </Div>
          <Div $flex $flexNone $mobile>
            <Logo width="50" height="50" />
          </Div>
          <Div>
            <H5 $mb="4">{location.name}</H5>
            <P $mb="4">{location.address}</P>
            <P $color={lightTheme.lightGray} $m="0">
              Date Created: {dateFormat(location.createdAt)}.
            </P>
          </Div>
        </Div>
        <Icon $rotate="90deg">
          <Chevron />
        </Icon>
      </Box>
    </Link>
  );
};
